<p>
  Logging you in...
</p>

Username: <input #userName type="text" />
Password: <input #password type="password" />
<input type="button" value="Login" (click)="Login(userName.value, password.value)"/>
